import { Header } from "../../components/public";
import { ModalProvider } from "../../utils/customHooks/ModalContext";
import { Outlet } from "react-router-dom";

const MainLayout = () => {
    return (
        <>
            <ModalProvider>
                <Header />
                <Outlet />
            </ModalProvider>
        </>
    );
};

export default MainLayout;
